import React, { useEffect, useState } from 'react';
import { showPopup }    from './helpers';
import { addCommas }    from './helpers';
import './index.css';
import PropertyDetails  from './PropertyDetails';
import EstimatedCosts   from './EstimatedCosts';


const App = () => {

  const [formData, setFormData] = useState({
    salePrice: 1500000,
    propertyType: '1',
    existingMortgage: true,
    sellerPowerOfAttorney: false,
    brokerCommission: 6,
    sellerAttorneyFee: 3500,
    buildingFlipTax: 0,
    buildingFlipTaxPercent: 0,
  });

  const [ isFee, setIsFee ] = useState({
    mortgageSatisfRecFee: 100,
    bankLoanSatisfFee: 50,
    sellerPowerAttorneyFee: 125,
    buildingMoveoutFee: 500,
    buildingManagingAgentCloseFee: 500,
    coopUCC3fee: 75,
    coopTransferTaxFee: 100,
    coopStockTransferTax: 50,
  });

  const [ userParams, setUserParams ] = useState({
    email: '',
    salePrice: 0,
    propertyType: 0,
    existingMortgage: 0,
    sellerPowerAttorney: 0,
    brokerCommissionPercent: 0,
    sellerAttorneyFee: 0,
    buildingFlipTax: 0,
    NYCBrokerCommissionPrice: 0,
    NYCBrokerCommissionPercent: 0,
    NYCtransferTaxPrice: 0,
    NYCtransferTaxPercent: 0,
    NYstateTransferTaxPrice: 0,
    NYstateTransferTaxPercent: 0,
    sellerAttorneyFeePrice: 0, 
    sellerAttorneyFeePercent: 0, 
    mortgageRecordingFeePrice: 0, 
    mortgageRecordingFeePercent: 0, 
    bankLoanSatisfactionFeePrice: 0,
    bankLoanSatisfactionFeePercent: 0,
    sellerPowerAttorneyFeePrice: 0,
    sellerPowerAttorneyFeePercent: 0,
    buildingMoveFeePrice: 0,
    buildingMoveFeePercent: 0,
    buildingAgentCloseFeePrice: 0, 
    buildingAgentCloseFeePercent: 0,
    buildingFliptaxPrice: 0,
    buildingFliptaxPercent: 0,
    coopUCCterminationFeePrice: 0,
    coopUCCterminationFeePercent: 0,
    coopTransferTaxPrice: 0,
    coopTransferTaxPercent: 0,
    coopStockTransferTaxPrice: 0,
    coopStockTransferTaxPercent: 0,
    totalSellerClosingCostsPrice: 0,
    totalSellerClosingCostsPercent: 0,
    netSalePrice: 0,
    netSalePercent: 0,
  });

  const [ brokerComissionPrice,   setBrokerComissionPrice ]   = useState(0);
  const [ nyTransferTaxRate,      setNyTransferTaxRate ]      = useState(0);
  const [ nyTransferTaxCost,      setNyTransferTaxCost ]      = useState(0);
  const [ nyStateTransferTaxRate, setNyStateTransferTaxRate ] = useState(0);
  const [ nyStateTransferTaxCost, setNyStateTransferTaxCost ] = useState(0);
  const [ attorneyFeePercent,     setAttorneyFeePercent ]     = useState(0);
  const [ isCost,                 setIsCost ]                 = useState(0);
  const [ isRevenue,              setIsRevenue ]              = useState(0);

  const getPropertyType = (type) => {
    let property = 'Condo';
    switch (type) {
      case '1':
        return property = 'Condo';
      case '2':
        return property = 'Co-op';
      case '3':
        return property = '1 to 3 Family House';
      case '4':
        return property = '4 Family House';
      case '5':
        return property = '5 or More Family House';
      case '6':
        return property = 'Commercial Real Estate';
      default:
        return 'Unknown';
    }
  };

  // Email values need to be updated
  useEffect(() => {
    setUserParams(prevState => ({
      ...prevState,
    salePrice: addCommas(formData.salePrice),
    propertyType: formData.propertyType,
    existingMortgage: formData.existingMortgage ? 'Yes' : 'No',
    sellerPowerAttorney: formData.sellerPowerOfAttorney ? 'Yes' : 'No',
    brokerCommissionPercent: formData.brokerCommission,
    sellerAttorneyFee: addCommas(formData.sellerAttorneyFee),
    buildingFlipTax: addCommas((formData.buildingFlipTaxPercent * formData.salePrice / 100).toFixed(2)),
    NYCBrokerCommissionPrice: addCommas(brokerComissionPrice),
    NYCBrokerCommissionPercent: formData.brokerCommission,
    NYCtransferTaxPrice: addCommas(nyTransferTaxCost),
    NYCtransferTaxPercent: nyTransferTaxRate,
    NYstateTransferTaxPrice: addCommas(nyStateTransferTaxCost),
    NYstateTransferTaxPercent: nyStateTransferTaxRate,
    sellerAttorneyFeePrice: addCommas(formData.sellerAttorneyFee), 
    sellerAttorneyFeePercent: attorneyFeePercent, 
    mortgageRecordingFeePrice: isFee.mortgageSatisfRecFee, 
    mortgageRecordingFeePercent: formData.existingMortgage ?(isFee.mortgageSatisfRecFee * 100 /formData.salePrice).toFixed(3) : 0, 
    sellerPowerAttorneyFeePrice: isFee.sellerPowerAttorneyFee,
    sellerPowerAttorneyFeePercent: formData.sellerPowerOfAttorney ? (isFee.sellerPowerAttorneyFee * 100 /formData.salePrice).toFixed(3) : 0,
    bankLoanSatisfactionFeePrice: isFee.bankLoanSatisfFee,
    bankLoanSatisfactionFeePercent: (isFee.bankLoanSatisfFee * 100 /formData.salePrice).toFixed(3),
    buildingMoveFeePrice: isFee.buildingMoveoutFee,
    buildingMoveFeePercent: isFee.buildingMoveoutFee ? (isFee.buildingMoveoutFee * 100 /formData.salePrice).toFixed(3) : 0,
    buildingAgentCloseFeePrice: isFee.buildingManagingAgentCloseFee, 
    buildingAgentCloseFeePercent: isFee.buildingManagingAgentCloseFee !==0 ? (isFee.buildingManagingAgentCloseFee * 100 /formData.salePrice).toFixed(3) : 0,
    buildingFliptaxPrice: addCommas((formData.buildingFlipTaxPercent * formData.salePrice / 100).toFixed(2)),
    buildingFliptaxPercent: formData.buildingFlipTaxPercent,
    coopUCCterminationFeePrice: isFee.coopUCC3fee,
    coopUCCterminationFeePercent: isFee.coopUCC3fee !== 0 ? (isFee.coopUCC3fee * 100 /formData.salePrice).toFixed(3) : 0,
    coopTransferTaxPrice: isFee.coopTransferTaxFee,
    coopTransferTaxPercent: isFee.coopTransferTaxFee !== 0 ? (isFee.coopTransferTaxFee * 100 /formData.salePrice).toFixed(3) : 0,
    coopStockTransferTaxPrice: isFee.coopStockTransferTax,
    coopStockTransferTaxPercent: isFee.coopStockTransferTax !==0 ? (isFee.coopStockTransferTax * 100 /formData.salePrice).toFixed(3) : 0,
    totalSellerClosingCostsPrice: addCommas(isCost),
    totalSellerClosingCostsPercent: (isCost * 100 /formData.salePrice).toFixed(2),
    netSalePrice: addCommas(isRevenue),
    netSalePercent: (isRevenue * 100 /formData.salePrice).toFixed(2),
    }));
  }, [formData, isFee]);

  useEffect(() => {
    
    setUserParams(prevState => ({
      ...prevState,
      propertyType: getPropertyType(formData.propertyType)
    }))
    console.log(userParams.propertyType, ' userParams.propertyType');
  }, [formData.propertyType, userParams.propertyType]);
  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // Validation for buildingFlipTaxPercent to ensure it's no more than 3 digits
    if (name === "buildingFlipTaxPercent" && value > 3) {
      showPopup(`The flip tax can be set anywhere between 0% and 3%.`);
      return; 
    }
    if (name === "brokerCommission" && value  > 101) {
      showPopup("Broker commission cannot be more than 100%");
      return;
    }
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const resetHandler = () => {
    setFormData({
      salePrice: 1500000,
      propertyType: '1',
      existingMortgage: true,
      sellerPowerOfAttorney: false,
      brokerCommission: 6,
      sellerAttorneyFee: 3500,
      buildingFlipTax: 0,
      buildingFlipTaxPercent: 0,
    });
    setIsFee({
      mortgageSatisfRecFee: 100,
      bankLoanSatisfFee: 50,
      sellerPowerAttorneyFee: 125,
      buildingMoveoutFee: 500,
      buildingManagingAgentCloseFee: 500,
      coopUCC3fee: 75,
      coopTransferTaxFee: 100,
      coopStockTransferTax: 50,
    });
  };

  // Broker Price
  const brokerComissionHandler = () => {
    let value = formData.salePrice * formData.brokerCommission / 100;
    setBrokerComissionPrice(value.toFixed(0));
  };

  // Seller's Attorney Fee
  const sellerAttorneyFeePercentageHandler = () => {
    let value = formData.sellerAttorneyFee * 100 / formData.salePrice;
    setAttorneyFeePercent(value.toFixed(3));
  };

  // NY City Taxes
  const calculateTransferTaxRate = () => {
    const { salePrice, propertyType } = formData;
    let taxRate = 0;
    let suplementTaxRate = 0;

    // suplementTaxRate Value based on table
    // if (salePrice >= 2000000 && salePrice < 3000000) {
    //     suplementTaxRate = 0.25;
    // } else if (salePrice >= 3000000 && salePrice < 5000000) {
    //     suplementTaxRate = 0.5;
    // } else if (salePrice >= 5000000 && salePrice < 10000000) {
    //     suplementTaxRate = 1.25;
    // } else if (salePrice >= 10000000 && salePrice < 15000000) {
    //     suplementTaxRate = 2.25;
    // } else if (salePrice >= 15000000 && salePrice < 20000000) {
    //     suplementTaxRate = 2.5;
    // } else if (salePrice >= 20000000 && salePrice < 25000000) {
    //     suplementTaxRate = 2.75;
    // } else if (salePrice >= 25000000) {
    //     suplementTaxRate = 2.9;
    // }

    console.log('suplementTaxRate =', suplementTaxRate);

    if (salePrice <= 500000) {
      // for Residential
      if (propertyType === '1' || propertyType === '2' || propertyType === '3') { // for Residential
        taxRate = 1.0 + suplementTaxRate;
      // for NON Residential
      } else {
        taxRate = 1.425;
      }
    } else {
      // for Residential
      if (propertyType === '1' || propertyType === '2' || propertyType === '3') { // for Residential
        taxRate = 1.425 + suplementTaxRate;
      // for NON Residential
      } else {
        taxRate = 2.625;
      }
    }
    console.log('suplementTaxRate =', suplementTaxRate);
    console.log('taxRate =', taxRate);

    let valueCost = formData.salePrice * taxRate / 100;
    setNyTransferTaxCost(valueCost.toFixed(0));
    setNyTransferTaxRate(taxRate);
  };

  // NY State transfer tax
  const calculateNYStateTransferTaxRate = () => {
    const { salePrice, propertyType } = formData;
    let taxRate = 0;

    if (salePrice < 3000000) {
      if (propertyType === '1' || propertyType === '2' || propertyType === '3') {
        taxRate = 0.40;
      } else {
        taxRate = 0.40;
      }
    } else {
      if (propertyType === '1' || propertyType === '2' || propertyType === '3') {
        taxRate = 0.65;
      } else {
        taxRate = 0.65;
      }
    }
    let valueCost = formData.salePrice * taxRate / 100;
    setNyStateTransferTaxCost(valueCost.toFixed(0));
    setNyStateTransferTaxRate(taxRate);
  };

  // Total Seller Closing Costs
  const calculateCosts = () => {
    let value = Number(brokerComissionPrice) + Number(nyStateTransferTaxCost) + Number(nyTransferTaxCost) + Number(formData.sellerAttorneyFee)
    + isFee.mortgageSatisfRecFee + isFee.bankLoanSatisfFee + isFee.sellerPowerAttorneyFee + isFee.buildingMoveoutFee + isFee.buildingManagingAgentCloseFee 
    + (formData.buildingFlipTaxPercent * formData.salePrice / 100) + isFee.coopUCC3fee + isFee.coopTransferTaxFee + isFee.coopStockTransferTax;
    setIsCost(value);
  };

  // Net Sale Proceeds
  const calculateRevenue = () => {
    let value = formData.salePrice - isCost;
    setIsRevenue(value);
  };
  
  useEffect(() => {
    brokerComissionHandler();
    calculateTransferTaxRate();
    calculateNYStateTransferTaxRate();
    sellerAttorneyFeePercentageHandler();
    calculateCosts();
    calculateRevenue();
  }, [formData, isFee, brokerComissionPrice]);

  useEffect(() => {
    // Move Out Fee & Managing Agent Close Fee
    if (formData.propertyType === '1' || formData.propertyType === '2') {
      setIsFee(prevState => ({
        ...prevState,
        buildingMoveoutFee: 500,
        buildingManagingAgentCloseFee: 500,
      }));
    }
    else {
      setIsFee(prevState => ({
        ...prevState,
        buildingMoveoutFee: 0,
        buildingManagingAgentCloseFee: 0,
      }));
    }
  }, [formData.propertyType, isFee.buildingMoveoutFee, isFee.buildingManagingAgentCloseFee]);

    // Mortgage satisfaction recording fee
    useEffect(() => {
      if (formData.propertyType === '2' ||  formData.existingMortgage === false) {
        setIsFee(prevState => ({
          ...prevState,
          mortgageSatisfRecFee: 0
        }));
      }
      else {
        setIsFee(prevState => ({
          ...prevState,
          mortgageSatisfRecFee: 100
        }));
      }
    }, [formData.propertyType, formData.existingMortgage, isFee.mortgageSatisfRecFee]);

    // Building flip tax
    useEffect(() => {
      if (formData.propertyType === '2') {
        setFormData(prevState => ({
          ...prevState,
          buildingFlipTaxPercent: 2,
        }));
      }
      else {
        setFormData(prevState => ({
          ...prevState,
          buildingFlipTax: 0
        }));
      }
    }, [formData.propertyType]);

    // Bank loan satisfaction fees
    useEffect(() => {
      if (formData.existingMortgage === false) {
        setIsFee(prevState => ({
          ...prevState,
          bankLoanSatisfFee: 0
        }));
      }
      else {
        setIsFee(prevState => ({
          ...prevState,
          bankLoanSatisfFee: 50
        }));
      }
    }, [formData.existingMortgage, isFee.bankLoanSatisfFee]);

    // Seller power of attorney recording fee
    useEffect(() => {
      if (formData.sellerPowerOfAttorney === true) {
        setIsFee(prevState => ({
          ...prevState,
          sellerPowerAttorneyFee: 125
        }));
      }
      else {
        setIsFee(prevState => ({
          ...prevState,
          sellerPowerAttorneyFee: 0
        }));
      }
    }, [formData.sellerPowerOfAttorney, isFee.sellerPowerAttorneyFee]);

  // CO-OP
  useEffect(() => {
    if (formData.propertyType === '2') {
      setIsFee(prevState => ({
        ...prevState,
        coopUCC3fee: 75,
        coopTransferTaxFee: 100,
        coopStockTransferTax: 50,
      }));
    }
    else {
      setIsFee(prevState => ({
        ...prevState,
        coopUCC3fee: 0,
        coopTransferTaxFee: 0,
        coopStockTransferTax: 0,
      }));
    }
  }, [formData.propertyType, isFee.coopUCC3fee, isFee.coopTransferTaxFee, isFee.coopStockTransferTax]);



  return (
    <div id="app" className="container">

       <div className="row justify-content-center">
          {/* <div className="col-12 text-center pb-4">
            <h2>Seller Closing Cost Calculator</h2>
          </div>
          <div className='w-100'></div> */}

          <PropertyDetails 
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            resetHandler={resetHandler}
            userParams={userParams} 
            setUserParams={setUserParams}
          />
          <EstimatedCosts 
            formData={formData}
            brokerComissionPrice={brokerComissionPrice}
            nyTransferTaxRate={nyTransferTaxRate}
            nyTransferTaxCost={nyTransferTaxCost}
            nyStateTransferTaxRate={nyStateTransferTaxRate}
            nyStateTransferTaxCost={nyStateTransferTaxCost}
            attorneyFeePercent={attorneyFeePercent}
            isFee={isFee}
            setIsFee={setIsFee}
            isCost={isCost}
            setIsCost={setIsCost}
            isRevenue={isRevenue}
            setIsRevenue={setIsRevenue}
            setFormData={setFormData}
            handleChange={handleChange}
            resetHandler={resetHandler}
            userParams={userParams} 
            setUserParams={setUserParams}
          />
          
          <div className='w-100'></div>
          {/* Popup */}
          <div className='col-12 col-md-10 col-lg-8'>
            <div id="popup" className="popup"></div>
          </div>
      </div>
    </div>
  );
}

export default App;
